import React, { Component } from 'react';
import {
    domainCoverageIsLoadedSelector,
    invalidCountSelector,
    monitorCountSelector,
    noRecordCountSelector,
    quarantineCountSelector,
    rejectCountSelector
} from '../../selectors/domain-coverage-selectors';

import DomainCoverageProgressStatement from '../../components/policy-progress/domain-coverage-progress-statement';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export class DomainCoverageProgressStatementContainer extends Component{
    render(){
        const { isLoaded, totalReject, totalQuarantine, totalMonitor, totalInvalid, totalNone } = this.props;

        return (
            <DomainCoverageProgressStatement
                isLoaded={isLoaded}
                totalReject={totalReject}
                totalQuarantine={totalQuarantine}
                totalMonitor={totalMonitor}
                totalInvalid={totalInvalid}
                totalNone={totalNone}
            />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isLoaded: domainCoverageIsLoadedSelector( state ),
        totalInvalid: invalidCountSelector( state ),
        totalMonitor: monitorCountSelector( state ),
        totalNone: noRecordCountSelector( state ),
        totalQuarantine: quarantineCountSelector( state ),
        totalReject: rejectCountSelector( state ),
    };
};

DomainCoverageProgressStatementContainer.propTypes = {
    isLoaded: PropTypes.bool.isRequired,
    totalInvalid: PropTypes.number.isRequired,
    totalMonitor: PropTypes.number.isRequired,
    totalNone: PropTypes.number.isRequired,
    totalQuarantine: PropTypes.number.isRequired,
    totalReject: PropTypes.number.isRequired,
};

export default connect( mapStateToProps )( DomainCoverageProgressStatementContainer );
